import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import TaskDescriptionModal from "../Modal/taskDescriptionModal";
import SoundManager from "../../services/SoundManager";

const ControlRoomNetwork = ({ currentScript, isTaskCompleted, audioMuted }) => {
  const [isTaskModalVisible, setIsTaskModalVisible] = useState(false);
  const openTaskModal = () => {
    SoundManager.playSfx('game-secondary-click');
    setIsTaskModalVisible(true);
  };
  const closeTaskModal = () => {
    SoundManager.playSfx('game-secondary-click');
    setIsTaskModalVisible(false);
  };
  return (
    <React.Fragment>
      {currentScript && (
        <div className="w-full h-full">
          <h1 className="text-2xl text-center mt-2">Control Room Network</h1>

          {"img" in currentScript && (
            <div className="relative w-full mt-4">
              {!isTaskCompleted && (
                <div
                  className="animate-pulse absolute top-0 md:top-2 right-2 flex gap-2 text-red-500 font-bold border rounded-full p-1 md:p-2 border-red-500 items-center shadow-lg shadow-red-500 cursor-pointer hover:scale-105 transition-all ease-out duration-100"
                  onClick={openTaskModal}
                >
                  <FontAwesomeIcon
                    icon={faTriangleExclamation}
                    className="text-lg md:text-3xl"
                  />
                  <h4 className="text-base md:text-lg">Security Breach</h4>
                </div>
              )}
              {"taskDescription" in currentScript && (
                <TaskDescriptionModal
                  isVisible={isTaskModalVisible}
                  message={currentScript["taskDescription"]}
                  onClose={closeTaskModal}
                />
              )}
              <div className="hidden min-[640px]:flex rounded-lg p-4 items-center">
                <img
                  src={require(`../../static/images/visuals/${
                    isTaskCompleted
                      ? currentScript["img"] + "_Next"
                      : currentScript["img"]
                  }.png`)}
                  alt="Control Room Network"
                  className="w-full rounded-lg"
                />
              </div>
              <div className="flex min-[640px]:hidden rounded-lg p-4 items-center mt-6">
                <img
                  src={require(`../../static/images/visuals/${
                    isTaskCompleted
                      ? currentScript["img"] + "_mobile_Next"
                      : currentScript["img"] + "_mobile"
                  }.png`)}
                  alt="Control Room Network"
                  className="w-full rounded-lg"
                />
              </div>
              <div className="absolute inset-0 w-full h-full pointer-events-none">
                <div
                  className="animate-communication absolute w-3 h-3 min-[640px]:w-4 min-[640px]:h-4 bg-blue-500 rounded-full"
                  style={{
                    animationDuration: "2s",
                    animationDelay: "0s",
                  }}
                >
                  <style jsx>{`
                    @media (max-width: 640px) {
                      div.animate-communication:first-of-type {
                        top: 30%;
                        left: 0%;
                      }
                    }
                    @media (min-width: 641px) {
                      div.animate-communication:first-of-type {
                        top: 30%;
                        left: 40%;
                      }
                    }
                  `}</style>
                </div>

                <div
                  className="animate-communication absolute w-3 h-3 min-[640px]:w-4 min-[640px]:h-4 bg-blue-500 rounded-full"
                  style={{
                    animationDuration: "2s",
                    animationDelay: "0s",
                  }}
                >
                  <style jsx>{`
                    @media (max-width: 640px) {
                      div.animate-communication:nth-of-type(2) {
                        top: 66%;
                        left: 0%;
                      }
                    }
                    @media (min-width: 641px) {
                      div.animate-communication:nth-of-type(2) {
                        top: 66%;
                        left: 40%;
                      }
                    }
                  `}</style>
                </div>
                <div
                  className={`${
                    isTaskCompleted &&
                    "taskId" in currentScript &&
                    currentScript["taskId"] === "3.4"
                      ? "none"
                      : "animate-communication absolute w-3 h-3 min-[640px]:w-4 min-[640px]:h-4 rounded-full bg-red-500"
                  } `}
                  style={{
                    animationDuration: "2s",
                    animationDelay: "1s",
                  }}
                >
                  <style jsx>{`
                    @media (max-width: 640px) {
                      div.animate-communication:nth-of-type(3) {
                        top: 88%;
                        left: 40%;
                      }
                    }
                    @media (min-width: 641px) {
                      div.animate-communication:nth-of-type(3) {
                        top: 89%;
                        left: 60%;
                      }
                    }
                  `}</style>
                </div>
                <div
                  className={`${
                    isTaskCompleted &&
                    "taskId" in currentScript &&
                    currentScript["taskId"] === "3.4"
                      ? "bg-blue-500"
                      : "bg-red-500"
                  } animate-communicationReverse absolute w-3 h-3 min-[640px]:w-4 min-[640px]:h-4 rounded-full`}
                  style={{
                    animationDuration: "2s",
                    animationDelay: "0s",
                  }}
                >
                  <style jsx>{`
                    @media (max-width: 640px) {
                      div.animate-communicationReverse {
                        top: 75%;
                        left: 71%;
                      }
                    }
                    @media (min-width: 641px) {
                      div.animate-communicationReverse {
                        top: 77%;
                        left: 75%;
                      }
                    }
                  `}</style>
                </div>

                {isTaskCompleted && "taskId" in currentScript && (
                  <div>
                    {currentScript["taskId"] === "3.1" && (
                      <div>
                        <div
                          className="animate-communicationVertical absolute w-3 h-3 min-[640px]:w-4 min-[640px]:h-4 bg-blue-500 rounded-full"
                          style={{
                            animationDuration: "2s",
                            animationDelay: "0s",
                          }}
                        >
                          <style jsx>{`
                            @media (max-width: 640px) {
                              div.animate-communicationVertical {
                                top: 43%;
                                left: 80%;
                              }
                            }
                            @media (min-width: 641px) {
                              div.animate-communicationVertical {
                                top: 43%;
                                left: 83%;
                              }
                            }
                          `}</style>
                        </div>
                        <div
                          className="animate-communicationVerticalUp absolute w-3 h-3 min-[640px]:w-4 min-[640px]:h-4 bg-red-500 rounded-full"
                          style={{
                            animationDuration: "2s",
                            animationDelay: "1.5s",
                          }}
                        >
                          <style jsx>{`
                            @media (max-width: 640px) {
                              div.animate-communicationVerticalUp {
                                top: 43%;
                                left: 84%;
                              }
                            }
                            @media (min-width: 641px) {
                              div.animate-communicationVerticalUp {
                                top: 43%;
                                left: 85%;
                              }
                            }
                          `}</style>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {((isTaskCompleted && currentScript["taskId"] === "3.3") ||
                  (!isTaskCompleted && currentScript["taskId"] === "3.4")) && (
                  <div
                    className="animate-communication absolute w-3 h-3 min-[640px]:w-4 min-[640px]:h-4 bg-red-500 rounded-full"
                    style={{
                      animationDuration: "2s",
                      animationDelay: "1.5s",
                    }}
                  >
                    <style jsx>{`
                      @media (max-width: 640px) {
                        div.animate-communication:last-of-type {
                          top: 87%;
                          left: 70%;
                        }
                      }
                      @media (min-width: 641px) {
                        div.animate-communication:last-of-type {
                          top: 89%;
                          left: 80%;
                        }
                      }
                    `}</style>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default ControlRoomNetwork;
